import { FieldTesterLocality } from 'api/model';

/**
 * Vem som gjorde jobbet, sett från jobbets län: en FT med hemankare i länet, en FT vars
 * hemankare ligger i andra län, eller en FT utan hemankare. Se FieldTesterAnchorCounties.
 */
const localityLabel: Record<FieldTesterLocality, string> = {
  [FieldTesterLocality.Local]: 'FT kopplad till länet',
  [FieldTesterLocality.OtherCounty]: 'FT från annat län',
  [FieldTesterLocality.NoHomeAnchor]: 'FT utan hemankare',
};

export default localityLabel;
